import React from "react";
import { Radio } from "antd";
import { UnorderedListOutlined, CalendarOutlined } from "@ant-design/icons";

/**
 * Small List/Calendar toggle reused across Dashboard, LeaveRequests and
 * Holidays so the three pages read consistently. "List" always stays each
 * page's original, unchanged behavior; "Calendar" is the new view.
 */
const ViewToggle = ({ value, onChange }) => (
  <Radio.Group value={value} onChange={(e) => onChange(e.target.value)} optionType="button" buttonStyle="solid">
    <Radio.Button value="list">
      <UnorderedListOutlined /> List
    </Radio.Button>
    <Radio.Button value="calendar">
      <CalendarOutlined /> Calendar
    </Radio.Button>
  </Radio.Group>
);

export default ViewToggle;
